import { render, staticRenderFns } from "./AddressSection.vue?vue&type=template&id=18d1ff1c&"
import script from "./AddressSection.vue?vue&type=script&lang=js&"
export * from "./AddressSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports